<template>
    <div class="home" :style="{minHeight: bodyHeight + 'px'}">
        <gSwiper />
        <gSite />
        <div class="gContent" :style="{minHeight: (bodyHeight - 256) + 'px'}">
            <router-view></router-view>
        </div>
        <gInfo />
        <gBottom />
        <gBackTop />
    </div>
</template>

<script>
    import gSwiper from "@components/gSwiper/gSwiper.vue";
    import gSite from "@components/gSite/gSite.vue";
    import gBottom from "@components/gBottom/gBottom.vue";
    import gBackTop from "@components/gBackTop/gBackTop.vue";
    import gInfo from "@components/gInfo/gInfo.vue";
    // import brandCard from "@components/homeC/brand-card.vue";
    // import news from "@components/homeC/news.vue";
    // import needs from "@components/homeC/needs.vue";
    // import hotPro from "@components/homeC/hot-pro.vue";
    // import productitem from "@components/homeC/product-item.vue";

    export default {
        name: "home",
        data() {
            return {
                bodyHeight: "800px"
            };
        },
        created() {
            this.bodyHeight = window.innerHeight ? window.innerHeight  : "800";
            document.title = "中国国际医疗器械博览会";
        },
        components: {
            gSwiper,
            gSite,
            gBottom,
            gBackTop,
            gInfo,
            // brandCard,
            // news,
            // needs,
            // hotPro,
            // productitem
        },
        computed: {},
        methods: {}
    };
</script>

<style scoped lang="scss">
    .home{
        background: #f5f5f5;
    }
    .gContent {
        background: #f5f5f5;
        width: 1200px;
        margin: 0 auto 0;
    }
</style>
